<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card>
        <div>
          <vs-table :max-items="5" pagination :data="managementData" search>
            <template slot="header">
              <div
                style="margin-right: auto; font-size: 1.5rem; font-weight: 550"
              >
                {{ $t("setup.label.IpPoolManagement") }}
              </div>
              <span class="vx-col order-1" style="margin-right: 10px">
                <v-select
                  label="text"
                  :reduce="(obj) => obj.value"
                  placeholder="Select Search Option"
                  :options="searchItems"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
              </span>

              <span class="vx-col order-1">
                <vs-button
                  icon-pack="feather"
                  @click="handleCreateIpPool"
                  size="small"
                >
                  {{ $t("setup.label.createIpPool") }}</vs-button
                >
              </span>
              <span class="vx-col order-1">
                <vs-button
                  icon-pack="feather"
                  @click="handleUpdateNetMask"
                  size="small"
                >
                  {{ $t("setup.label.UpdateNetMask") }}</vs-button
                >
              </span>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.IpAddress") }}</vs-th>
              <vs-th>{{ $t("setup.label.NetMark") }}</vs-th>
              <vs-th>{{ $t("setup.label.IpType") }}</vs-th>
              <vs-th>{{ $t("setup.label.CoustomerId") }}</vs-th>
              <vs-th>{{ $t("setup.label.CustomerName") }}</vs-th>
              <vs-th>{{ $t("setup.label.Status") }}</vs-th>
              <vs-th>{{ $t("setup.label.Notes") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(uploads, index) in data">
                <vs-td :data="uploads.ipAddress">{{ uploads.ipAddress }}</vs-td>
                <vs-td :data="uploads.ipPoolDescription">{{
                  uploads.ipPoolDescription
                }}</vs-td>
                <vs-td :data="uploads.typeCodeValue">{{
                  uploads.typeCodeValue
                }}</vs-td>
                <vs-td :data="uploads.clientId">{{ uploads.clientId }}</vs-td>
                <vs-td :data="uploads.groupAddress">{{
                  uploads.groupAddress
                }}</vs-td>
                <vs-td :data="uploads.status">{{ uploads.status }}</vs-td>
                <vs-td :data="uploads.notes">{{ uploads.notes }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('inventory.label.Edit')"
                      class="text-warning icon_row"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="handleEdit(uploads)"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <div class="centerx">
            <vs-popup
              classContent="popup-example"
              :title="$t('setup.label.createIpPool')"
              :active.sync="bulkUploadsPopup"
              class="popup-close"
            >
              <ValidationObserver ref="observer">
                <form>
                  <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.IpAddress')"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('setup.label.IpAddress')"
                            class="min-w-200 w-full mb-2 starlabel"
                            v-model="createClosedUser.ipAddress"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.Subnet')"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('setup.label.Subnet')"
                            class="min-w-200 w-full mb-2 starlabel"
                            v-model="createClosedUser.subnet"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <small class="date-label font-semibold"
                          >{{ $t("setup.label.IpType")
                          }}<span class="required"> *</span></small
                        >
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.IpType')"
                          :key="resetKey"
                        >
                          <v-select
                            label="mCodeValue"
                            v-model="createClosedUser.type"
                            :options="infoDataTemplatemanagement"
                            :placeholder="$t('placeholder.label.SelectOne')"
                            :reduce="(mCodeValue) => mCodeValue.id"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            class="min-w-200 w-full mb-2"
                          >
                          </v-select>
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button
                        style="margin-left: 220px"
                        type="border"
                        @click="bulkUploadsPopup = false"
                        >{{ $t("setup.label.Cancel") }}</vs-button
                      >
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button @click="createIpPoolMethod">{{
                        $t("setup.label.Submit")
                      }}</vs-button>
                    </span>
                  </div>
                </form>
              </ValidationObserver>
            </vs-popup>
          </div>
          <div class="centerx">
            <vs-popup
              classContent="popup-example"
              :title="$t('setup.label.updateNetMask')"
              :active.sync="updateNetMaskPopup"
              class="popup-close"
            >
              <form>
                <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                  <div class="vx-col sm:w-full md:w-1/2">
                    <div class="dropdown-with-label">
                      <vs-input
                        :label="$t('setup.label.IpAddress')"
                        class="min-w-200 w-full mb-2 starlabel"
                        v-model="createClosedUser.ipAddress"
                      />
                    </div>
                  </div>
                  <div class="vx-col sm:w-full md:w-1/2">
                    <div class="dropdown-with-label">
                      <vs-input
                        :label="$t('setup.label.Subnet')"
                        class="min-w-200 w-full mb-2 starlabel"
                        v-model="createClosedUser.subnet"
                      />
                    </div>
                  </div>
                </div>

                <div class="vx-row">
                  <span class="ml-4 mr-1">
                    <vs-button
                      style="margin-left: 220px"
                      type="border"
                      @click="updateNetMaskPopup = false"
                      >{{ $t("setup.label.Cancel") }}</vs-button
                    >
                  </span>
                  <span class="ml-1 mr-2">
                    <vs-button @click="createIpPoolMethod">{{
                      $t("setup.label.Submit")
                    }}</vs-button>
                  </span>
                </div>
              </form>
            </vs-popup>
          </div>
          <div class="centerx">
            <vs-popup
              classContent="popup-example"
              :title="$t('setup.label.editIpPool')"
              :active.sync="editIp"
              class="popup-close"
            >
              <ValidationObserver ref="observer1">
                <form>
                  <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.IpAddress')"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('setup.label.IpAddress')"
                            class="min-w-200 w-full mb-2 starlabel"
                            v-model="updateIp.ipAddress"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.Notes')"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('setup.label.Notes')"
                            class="min-w-200 w-full mb-2 starlabel"
                            v-model="updateIp.notes"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="vx-col sm:w-full md:w-1/2">
                    <div class="dropdown-with-label">
                      <small class="date-label font-semibold"
                        >{{ $t("setup.label.Status")
                        }}<span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('setup.label.Status')"
                        :key="resetKey"
                      >
                        <v-select
                          v-model="updateIp.statusType"
                          :options="searchItems"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                        >
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button
                        style="margin-left: 220px"
                        type="border"
                        @click="bulkUploadsPopup = false"
                        >{{ $t("setup.label.Cancel") }}</vs-button
                      >
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button @click="updateUser">{{
                        $t("setup.label.Update")
                      }}</vs-button>
                    </span>
                  </div>
                </form>
              </ValidationObserver>
            </vs-popup>
          </div>
          <validation-popup
            :errorMessage="errorMessage"
            :warningPopup="warningPopup"
            :warningText="warningText"
            @closeWarning="warningPopup = false"
          ></validation-popup>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { AtomSpinner } from "epic-spinners";
export default {
  data() {
    return {
      resetKey: 0,
      loading: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      bulkUploadsPopup: false,
      updateNetMaskPopup: false,
      editIp: false,
      searchItems: [
        "All",
        "Intermediate",
        "Free",
        "Allocated",
        "Blocked",
        "Terminated",
      ],
      createClosedUser: {
        ipAddress: "",
        subnet: "",
        type: "",
      },
      updateIp: {
        statusType: "",
      },
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    AtomSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    managementData() {
      return this.$store.getters["ipManagement/GetIpManagementList"];
    },
    infoDataTemplatemanagement() {
      return this.$store.getters["ipManagement/GetManagementInfo"];
    },
  },
  watch: {
    bulkUploadsPopup(newValue) {
      if (newValue) this.ipManagementInfoTemp();
    },
  },
  methods: {
    async getDataUploads() {
      this.loading = true;
      try {
        await this.$store.dispatch("ipManagement/setIpManagementGroup");
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async ipManagementInfoTemp() {
      this.loading = true;
      try {
        await this.$store.dispatch("ipManagement/setManagementInfo");
      } catch (e) {
        // this.errorMessage = e.message.replace("The parameter", "");
        // this.warningPopup = true;
        // this.errors = e.message.errors;
      }
      this.loading = false;
    },
    handleCreateIpPool() {
      this.resetKey++;
      this.createClosedUser.ipAddress = "";
      this.createClosedUser.subnet = "";
      this.createClosedUser.type = "";
      this.bulkUploadsPopup = true;
    },
    handleUpdateNetMask() {
      this.resetKey++;
      this.updateNetMaskPopup = true;
    },
    handleEdit(data) {
      this.updateIp = data;
      this.updateIp.statusType = data.status;
      this.editIp = true;
    },
    async createIpPoolMethod() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        await this.$store.dispatch(
          "inventory/createIpPoolAction",
          this.createClosedUser
        );
        this.bulkUploadsPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Statement Created Successfully!",
          type: "success",
        });
        this.getDataUploads();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async updateUser() {
      const isValid = await this.$refs.observer1.validate();
      if (!isValid) return;
      try {
        const payload = {
          id: this.updateIp.id,
          data: this.updateIp,
        };
        payload.data.statusType = this.updateIp.statusType.slice(0, 1);
        delete payload.data.id;
        delete payload.data.clientId;
        delete payload.data.status;
        delete payload.data.subnet;
        delete payload.data.type;
        await this.$store.dispatch(
          "ipManagement/updateManagementInfo",
          payload
        );
        this.editIp = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Statement Updated Successfully!",
          type: "success",
        });
        this.getDataUploads();
      } catch (e) {
        this.editIp = false;
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
  },
  created() {
    this.getDataUploads();
    this.ipManagementInfoTemp();
  },
};
</script>
